export function initBackToTop() {
	const btn = document.getElementById('btn-back-top');
	if (!btn) return;

	btn.addEventListener('click', () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	});
}
